/* eslint-disable */
// <defs><style>.cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}.cls-17{fill:url(#linear-gradient-17);}.cls-18{fill:url(#linear-gradient-18);}.cls-19{fill:url(#linear-gradient-19);}.cls-20{fill:url(#linear-gradient-20);}.cls-21{fill:url(#linear-gradient-21);}.cls-22{fill:url(#linear-gradient-22);}</style>
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';
export const SvgLocationSearch = ({ size }) => {
    return (
        <Svg
   height={size}
   width={size}
   style="enable-background:new 0 0 268 270;"
   y="0px"
   x="0px"
   version="1.1"
   viewBox="0 0 268 270"
   id="master-artboard">
  
  <Path
     id="path2"
     transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
     fill="none"
      stroke= "#000000" 
      strokeWidth="3"
     d="M137.5,146.1"
     class="st0" />
  <Path
     id="path4"
     transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
     fill="#c2c2c2"
      fillOpacity="1"
     d="M137.7,203.7c1-19.2,11.5-50.3,26.8-69.8c8.3-10.7,12.2-21.1,12.2-27.4c0-21.9-17.6-39.7-39.2-39.7h0
			c-21.6,0-39.2,17.8-39.2,39.7c0,6.3,3.8,16.7,12.2,27.4c15.3,19.6,25.8,50.7,26.8,69.8H137.7z"
     class="st1" />
  <Path
     id="path6"
     fill="#c2c2c2"
     transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
     d="M139.2,205.2h-3.3l-0.1-1.4c-0.9-18.4-11.1-49.3-26.5-69c-9.2-11.8-12.5-22.3-12.5-28.3c0-22.7,18.3-41.2,40.7-41.2
			c22.4,0,40.7,18.5,40.7,41.2c0,6-3.3,16.5-12.5,28.3c-15.4,19.7-25.6,50.5-26.5,69L139.2,205.2L139.2,205.2z M137.5,68.3
			c-20.8,0-37.7,17.1-37.7,38.2c0,5.2,3.1,15.3,11.8,26.4c13.1,16.7,22.5,41.3,25.9,60c3.4-18.7,12.8-43.3,25.9-60
			c8.7-11.2,11.8-21.2,11.8-26.4C175.2,85.4,158.3,68.3,137.5,68.3L137.5,68.3z" />
  <Path
     id="path8"
     fill="#ffffff"
     transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
     d="M 153.900003 105 A 16.6 16.6 0 0 1 137.300003 121.6 A 16.6 16.6 0 0 1 120.700003 105 A 16.6 16.6 0 0 1 137.300003 88.4 A 16.6 16.6 0 0 1 153.900003 105 Z" />
</Svg>


    )
}

